import { render, staticRenderFns } from "./TransactionConfigDetailList.vue?vue&type=template&id=6f6e2000&scoped=true&"
import script from "./TransactionConfigDetailList.vue?vue&type=script&lang=js&"
export * from "./TransactionConfigDetailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6e2000",
  null
  
)

export default component.exports